import { loadModules, setDefaultOptions } from 'esri-loader'

export const ARCGIS_VERSION = '4.33'
export const ARCGIS_API_URL = `https://js.arcgis.com/${ARCGIS_VERSION}/`
export const ARCGIS_CSS_URL = `${ARCGIS_API_URL}esri/themes/light/main.css`

const ARCGIS_API_KEY = process.env.VUE_APP_ARCGIS_API_KEY || ''

setDefaultOptions({ url: ARCGIS_API_URL, css: false })

let configPromise = null

export function ensureArcgisCss() {
  if (typeof document === 'undefined') return
  if (document.querySelector(`link[data-arcgis-css="${ARCGIS_API_URL}"]`)
    || document.querySelector(`link[href="${ARCGIS_CSS_URL}"]`)) {
    return
  }
  const head = document.head || document.getElementsByTagName('head')[0]
  if (!head) return
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = ARCGIS_CSS_URL
  link.setAttribute('data-arcgis-css', ARCGIS_API_URL)
  head.appendChild(link)
}

function ensureArcgisConfig() {
  if (!configPromise) {
    configPromise = loadModules(['esri/config'], { url: ARCGIS_API_URL, css: false })
      .then(([esriConfig]) => {
        if (ARCGIS_API_KEY) Object.assign(esriConfig, { apiKey: ARCGIS_API_KEY })
      })
      .catch(err => {
        configPromise = null
        throw err
      })
  }
  return configPromise
}

/**
 * Load ArcGIS AMD modules from the shared CDN version (with CSS and global config).
 * @param {string[]} modules
 * @returns {Promise<any[]>}
 */
export async function loadArcgisModules(modules) {
  ensureArcgisCss()
  await ensureArcgisConfig()
  return loadModules(modules, { url: ARCGIS_API_URL, css: false })
}

/** Destroy an ArcGIS view safely (frees the WebGL context). */
export function destroyArcgisView(view) {
  if (!view || view.destroyed) return
  try {
    view.destroy()
  } catch (e) {
    // ignore
  }
}
